// extracted by mini-css-extract-plugin
export default {"container":"VO-z","title":"WO-z","link":"XO-z"};